import { configurationQuery, timeFormatQuery } from './graphql/configuration.queries.js'
import { gqlQuery } from './requests.service'

export const getConfiguration = gqlQuery({
  key: 'SITE_CONFIGURATION',
  query: configurationQuery,
})

export const getTimeFormat = gqlQuery({
  key: 'SITE_CONFIGURATION_TIME_FORMAT',
  query: timeFormatQuery,
})
